import React from "react";

function IconView() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.06 9.8a10.68 10.68 0 0119.88 0c.07.17.07.37 0 .54a10.68 10.68 0 01-19.88 0 .75.75 0 010-.55zm1.51.27a9.18 9.18 0 0016.86 0 9.18 9.18 0 00-16.86 0z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 7.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM6.25 10a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0z"
      />
    </svg>
  );
}

export default IconView;
